<template>
  <div class="main-content">
    <div class="px-1 px-md-4 mx-1 mx-md-2">
      <div class="container-fluid">
        <page-header
          :page="{
            icon: 'fa fa-shield-alt',
            title: 'Política de Privacidad',
            routes: ['Inicio', 'Política de Privacidad'],
          }"
        />
        <div>
          <div class="main-page-container">
            <h5>Introducción</h5>
            <hr />
            <p>
              Este documento describe la Política de Privacidad aplicable al
              acceso y uso de los servicios ofrecidos a través de la aplicación
              mipe.dde.pr (la "Aplicación"). Al acceder simplemente a la
              Aplicación, usted ("Usted" o el "Usuario") acepta automáticamente
              las Políticas de Privacidad descritas en este documento. Por lo
              tanto, si no está de acuerdo con estas Políticas de Privacidad
              obligatorias y vinculantes, debe abstenerse de acceder a
              mipe.dde.pr y utilizar sus servicios y aplicaciones.
            </p>
            <p>
              Todo el texto, información, datos, fotografías, gráficos, código
              HTML, software de computadora, código fuente y objeto, clips de
              audio y video, marcas comerciales y logotipos (en adelante,
              "Contenido") presentes en este sitio web, servicios de
              dispositivos móviles o aplicaciones para dispositivos móviles
              (colectivamente denominados "Aplicación") son propiedad de MIPE
              con correo electrónico
              <a href="mailto:info@de.gov.pr">info@de.gov.pr</a>
              y número de teléfono (787) 773-6178.
            </p>
            <p>Uso del Contenido y Derechos de Propiedad Intelectual</p>
            <p>Limitaciones en el Uso del Contenido</p>
            <p>
              Los usuarios solo pueden utilizar el Contenido en un dispositivo
              móvil (por ejemplo, Apple iPhone o iPad, dispositivo Android o
              dispositivo móvil Microsoft Windows) que posean o controlen
              exclusivamente para fines personales, internos y no comerciales.
              Cualquier otro uso del contenido, incluido, entre otros, su
              republicación, no está permitido sin el previo consentimiento por
              escrito de Mi Portal Especial o mipe.dde.pr. Cualquier usuario que
              infrinja de manera demostrable los derechos de propiedad
              intelectual de un tercero al retransmitir o publicar material
              vinculado desde esta Aplicación que viole los derechos de autor u
              otros derechos legales de dicho tercero quedará excluido de usar
              esta Aplicación.
            </p>
            <p>Derechos de Marca Comercial</p>
            <p>
              Todas las marcas comerciales utilizadas en esta Aplicación son
              propiedad de Mi Portal Especial. Sin embargo, otras marcas
              comerciales que no sean propiedad de Mi Portal Especial pueden
              utilizarse con el permiso de sus respectivos propietarios. Ningún
              tercero puede utilizar o reproducir ninguna marca comercial,
              incluidos, entre otros, logotipos y nombres de dominio de
              Internet, que utilicen las marcas comerciales de MIPE y
              mipe.dde.pr (ya sea que se utilicen con letras mayúsculas o
              espacios) sin el previo consentimiento por escrito de Mi Portal
              Especial y mipe.dde.pr o del propietario de la marca comercial.
            </p>
            <p>Derechos Limitados de Uso</p>
            <p>
              Aparte del derecho de uso no exclusivo, no sub-licenciable, no
              transferible, personal y limitado otorgado a los usuarios como se
              describe aquí, la inclusión de dicho contenido o partes de este en
              esta Aplicación o el acceso del usuario al mismo no confiere
              ningún derecho sobre dicho contenido o partes de este. MIPE será
              el único responsable de todo el mantenimiento y soporte de la
              Aplicación; ningún tercero, según se define en este documento,
              será responsable de proporcionar servicios de mantenimiento o
              soporte para la Aplicación.
            </p>
            <p>
              Mipe.dde.pr se toma su privacidad en serio y está comprometido a
              proteger su información personal. Esta Política de Privacidad le
              informa cómo recopilamos, utilizamos, compartimos y protegemos su
              información personal cuando utiliza nuestra aplicación.
            </p>
            <h5>Información que Recopilamos y Utilizamos</h5>
            <hr />
            <p>Registro y Consentimiento</p>
            <p>
              Para acceder y utilizar la Aplicación, los usuarios deben
              registrarse y proporcionar información precisa y actual durante el
              registro. Al utilizar, acceder, descargar, instalar, obtener o
              proporcionar información desde y hacia esta Aplicación, acepta
              haber leído y aceptado estos Términos y Condiciones y esta
              Política de Privacidad.
            </p>
            <p>Licencia de Uso</p>
            <p>
              Le otorgamos una licencia personal, no exclusiva, no transferible
              y revocable para utilizar la Aplicación conforme a estos Términos.
              No tiene derecho a sublicenciar, vender, alquilar, arrendar,
              distribuir o transferir de otra manera los derechos otorgados bajo
              esta licencia.
            </p>
            <p>Restricciones y Cumplimiento</p>
            <ul>
              <li>
                <p>
                  Uso Legal: No puede utilizar la Aplicación de manera que viole
                  las leyes aplicables o infrinja los derechos de terceros.
                </p>
              </li>
              <li>
                <p>
                  Actividades Fraudulentas o Ilegales: No debe utilizar la
                  Aplicación de manera fraudulenta o para fines ilegales.
                </p>
              </li>
              <li>
                <p>
                  Remoción de Usuarios: La Compañía se reserva el derecho de
                  eliminar o prohibir a cualquier usuario utilizar esta
                  Aplicación a su entera discreción.
                </p>
              </li>
            </ul>
            <p>Consecuencias por No Cumplir</p>
            <p>
              Los usuarios deben dejar de utilizar esta Aplicación de inmediato
              si no están de acuerdo o no aceptan todos estos Términos y
              Condiciones o esta Política de Privacidad. El incumplimiento puede
              resultar en la revocación de su licencia para utilizar la
              Aplicación y otras posibles acciones legales.
            </p>
            <p>Tipos de Información Recopilada</p>
            <ul>
              <li>
                <p>
                  Información Personal Obligatoria: Los datos mínimos requeridos
                  para utilizar nuestros servicios incluyen su nombre, apellido,
                  fecha de nacimiento, número de móvil, proveedor de servicios
                  móviles y dirección de correo electrónico. Estos detalles son
                  necesarios para mejorar la calidad del servicio.
                </p>
              </li>
              <li>
                <p>
                  Información Personal Adicional: Podemos recopilar información
                  adicional que usted proporcione voluntariamente, como su
                  código postal, etnia y nacionalidad. Esta información se
                  utiliza para mejorar la calidad del servicio y cumplir con
                  requisitos específicos de los clientes.
                </p>
              </li>
              <li>
                <p>
                  Información del Dispositivo: Podemos recopilar información
                  sobre su dispositivo móvil, como su identificador único de
                  dispositivo y otros detalles técnicos.
                </p>
              </li>
            </ul>
            <p>Consecuencias de no Proporcionar</p>
            <p>
              Información Si elige no proporcionar información obligatoria, es
              posible que no podamos ofrecerle nuestros servicios o que algunas
              funcionalidades estén limitadas. Por ejemplo, sin una dirección de
              correo electrónico válida, no podrá recibir notificaciones
              importantes.
            </p>
            <h5>Uso de la Información</h5>
            <hr />
            <p>Uso General</p>
            <p>
              Recopilamos y utilizamos su información con el máximo respeto por
              su privacidad. A continuación, describimos las formas específicas
              en las que se utiliza su información.
            </p>
            <p>Provisión y Mantenimiento de la Aplicación</p>
            <p>
              Su información personal es crucial para permitirnos proporcionar y
              mantener los servicios ofrecidos a través de la Aplicación.
            </p>
            <p>
              Comunicación
            </p>
            <ul>
              <li>
                <p>
                  Consultas y Comentarios de los Usuarios: Podemos utilizar su
                  información de contacto para responder a sus preguntas,
                  comentarios o solicitudes.
                </p>
              </li>
              <li>
                <p>
                  Notificaciones y Actualizaciones: También podemos utilizar sus
                  detalles de contacto para enviarle actualizaciones importantes
                  sobre la Aplicación, como nuevas características, períodos de
                  mantenimiento o cambios en esta Política de Privacidad.
                </p>
              </li>
            </ul>
            <p>
              Mejoras en la Aplicación
            </p>
            <ul>
              <li>
                <p>
                  Análisis de Datos: Analizamos información de uso agregada y no
                  identificable personalmente para mejorar la funcionalidad y el
                  rendimiento de la Aplicación.
                </p>
              </li>
              <li>
                <p>
                  Experiencia del Usuario: Podemos utilizar sus datos de
                  actividad para personalizar su experiencia dentro de la
                  Aplicación, haciéndola más relevante y valiosa para usted.
                </p>
              </li>
            </ul>
            <p>Cumplimiento y Obligaciones</p>
            <p>
              Legales Podemos utilizar su información para cumplir con las
              leyes, regulaciones y procesos legales aplicables y proteger los
              derechos y propiedades suyos y de la Compañía.
            </p>
            <p>Retención de Datos</p>
            <p>
              Sus datos se conservarán solo durante el tiempo necesario para los
              fines establecidos en esta Política de Privacidad, a menos que la
              ley requiera o permita un período de retención más prolongado.
            </p>
            <p>Opción de Exclusión y Preferencias del Usuario</p>
            <p>
              Puede optar por no recibir comunicaciones no esenciales y
              actualizar sus preferencias en la configuración de la Aplicación.
            </p>
            <h5>Compartir Información</h5>
            <hr />
            <p>Política General</p>
            <p>
              Valoramos enormemente su privacidad y nos comprometemos a
              compartir su información personal únicamente de acuerdo con esta
              Política de Privacidad y nuestros Términos y Condiciones.
            </p>
            <p>Con Nuestros Clientes</p>
            <p>
              Dado que brindamos servicios a varias empresas y organizaciones,
              podemos compartir información esencial para cumplir con nuestras
              obligaciones contractuales y garantizar la entrega eficiente de
              los servicios que ha solicitado.
            </p>
            <p>Con Proveedores de Servicios</p>
            <p>
              Podemos compartir su información con terceros de confianza que nos
              ayudan a operar nuestro sitio web, mantener la Aplicación y
              brindarle servicios. Tenga la seguridad de que estos socios se
              adhieren a nuestras estrictas pautas de privacidad.
            </p>
            <p>Enlaces Externos</p>
            <p>
              Proporcionamos enlaces externos dentro de la Aplicación para
              conectarlo con la empresa o organización cliente de la que busca
              servicios.
            </p>
            <p>Requisitos Legales y Protección de Derechos</p>
            <p>
              Es posible que sea necesario divulgar información cuando lo exija
              la ley o cuando dicha divulgación sea esencial para proteger sus
              derechos, nuestros derechos, nuestra propiedad o la seguridad de
              las personas.
            </p>
            <h5>Nuestra Política con Respecto a Menores de Edad</h5>
            <hr />
            <p>
              Nuestras aplicaciones están diseñadas principalmente para su uso
              por adultos. Si llegamos a tener conocimiento de que un individuo
              menor de 16 años ha proporcionado información personal sin el
              consentimiento de sus padres o tutores, le instamos a que se
              comunique con nosotros utilizando los detalles de contacto a
              continuación. Tomaremos las medidas necesarias para eliminar dicha
              información y cerrar cualquier cuenta que el menor pueda haber
              creado con nosotros.
            </p>
            <h5>Seguridad de Datos</h5>
            <hr />
            <p>
              Priorizamos la protección de la información personal que
              recopilamos y almacenamos, tomando medidas razonables para
              garantizar la seguridad. Sin embargo, es importante tener en
              cuenta que ninguna transmisión de datos por Internet o sistema de
              almacenamiento puede garantizar una seguridad completa, y no
              podemos garantizar la seguridad de sus datos.
            </p>
            <p>
              Además, es posible que incluyamos enlaces a otros sitios web que
              puedan ser beneficiosos. Si bien nos esforzamos por asegurarnos de
              que estos sitios cumplan con nuestros altos estándares, es
              importante entender que Mipe.dde.pr y todas sus subsidiarias no
              asumen responsabilidad por el contenido, acciones o políticas de
              sitios web de terceros. Además, no somos responsables de los
              avisos de privacidad o prácticas de privacidad de estos sitios web
              externos.
            </p>
            <h5>
              Cookies y Tecnologías Similares Utilizadas en Nuestra Aplicación
            </h5>
            <hr />
            <p>
              Mipe.dde.pr utiliza cookies y tecnologías similares para
              proporcionar una experiencia personalizada y mejorar nuestros
              servicios. Esta sección explica cómo utilizamos estas tecnologías
              y cómo puede controlar la configuración de las cookies.
            </p>
            <p>
              ¿Qué son las cookies?
            </p>
            <p>
              Las cookies son pequeños datos almacenados en su dispositivo
              cuando utiliza nuestra aplicación. Estas cookies nos permiten
              reconocerlo y recordar sus preferencias la próxima vez que visite
              nuestra plataforma. Tenga la seguridad de que estas cookies no
              contienen información personal identificable.
            </p>
            <p>
              Tipos de cookies que utilizamos
            </p>
            <ul>
              <li>
                <p>Cookies estrictamente necesarias</p>
                <p>
                  Estas cookies son esenciales para que nuestra aplicación
                  funcione correctamente. Le permiten navegar por la plataforma
                  y utilizar características importantes.
                </p>
              </li>
              <li>
                <p>Cookies de rendimiento y análisis</p>
                <p>
                  Utilizamos herramientas como Google Analytics para comprender
                  cómo los usuarios interactúan con nuestra aplicación. Esto nos
                  ayuda a mejorar la calidad de nuestros servicios y tomar
                  decisiones informadas sobre el diseño y la funcionalidad de la
                  aplicación.
                </p>
              </li>
              <li>
                <p>Cookies de funcionalidad</p>
                <p>
                  Estas cookies mejoran su experiencia personalizando ciertas
                  características de la aplicación según sus preferencias. Por
                  ejemplo, recordamos su idioma preferido o detalles de inicio
                  de sesión, para que no tenga que ingresarlos cada vez que
                  visita.
                </p>
              </li>
              <li>
                <p>Cookies de publicidad y seguimiento</p>
                <p>
                  Utilizamos estas cookies para mostrarle anuncios relevantes y
                  medir la efectividad de nuestras campañas de marketing. No
                  compartimos información personal con anunciantes.
                </p>
              </li>
              <li>
                <p>Control de cookies</p>
                <p>
                  Puede controlar y gestionar sus preferencias de cookies a
                  través de la configuración de su dispositivo o navegador. La
                  mayoría de los navegadores le permiten bloquear o eliminar
                  cookies y configurar notificaciones cuando se colocan cookies.
                  Tenga en cuenta que deshabilitar ciertas cookies puede afectar
                  la funcionalidad de nuestra aplicación.
                </p>
              </li>
              <li>
                <p>Cookies de terceros</p>
                <p>
                  Puede encontrarse con cookies de terceros en nuestra
                  aplicación. Estas cookies son establecidas por socios
                  externos, como proveedores de servicios de análisis o redes de
                  publicidad. Le recomendamos consultar las políticas de
                  privacidad de estos terceros para obtener más información
                  sobre cómo utilizan las cookies.
                </p>
              </li>
            </ul>
            <p>
              Cambios en la política de cookies
            </p>
            <p>
              Nos reservamos el derecho de actualizar nuestra política de
              cookies en el futuro para reflejar cambios en nuestras prácticas o
              servicios. Cualquier cambio significativo se comunicará a través
              de nuestra aplicación.
            </p>
            <p>
              Preguntas y contacto
            </p>
            <p>
              Si tiene alguna pregunta o inquietud acerca de nuestra política de
              cookies, no dude en ponerse en contacto con nosotros en
              <b>TBD</b>
              . Estaremos encantados de ayudarle.
            </p>
            <p>
              Por favor, tenga en cuenta que nuestro compromiso es proteger su
              privacidad y asegurarnos de que tenga control sobre sus datos
              mientras usa nuestra aplicación.
            </p>
            <h5>Cambios en la Política de Privacidad</h5>
            <hr />
            <p>
              Nos reservamos el derecho de actualizar esta Política de
              Privacidad en cualquier momento. Le informaremos de cualquier
              cambio significativo a través de la aplicación o mediante medios
              alternativos.
            </p>
            <h5>Derechos Generales</h5>
            <hr />
            <ul>
              <li>
                <p>
                  Si desea darse de baja por completo, contáctenos en
                  <b>TBD</b>
                  .
                </p>
              </li>
              <li>
                <p>
                  Si desea que eliminemos su información de nuestros registros,
                  no dude en ponerse en contacto con nosotros en
                  <b>TBD</b>
                  y responderemos en un plazo razonable. Tenga en cuenta que, en
                  algunos casos, podemos estar obligados a retener información
                  específica debido a requisitos legales y para nuestros fines
                  legítimos de negocio.
                </p>
              </li>
            </ul>
            <h5>Jurisdicción</h5>
            <hr />
            <p>
              Esta Política de Privacidad está sujeta a las leyes del
              Commonwealth de Puerto Rico, incluidos los reglamentos federales
              aplicables. Los usuarios aceptan someterse a la jurisdicción tanto
              del Tribunal Superior de Puerto Rico como del Tribunal de Distrito
              Federal, renunciando expresamente a cualquier otra jurisdicción.
            </p>
            <h5>Contacto</h5>
            <hr />
            <p>
              Si tiene alguna pregunta, comentario o inquietud con respecto a
              esta Política de Privacidad, no dude en ponerse en contacto con
              nosotros en
              <b>TBD</b>
              .
            </p>
            <h5>Fecha de Entrada en Vigor y Últimas Actualizaciones</h5>
            <hr />
            <p>
              Esta Política de Privacidad entra en vigor a partir del 14 de
              agosto de 2024. La actualización más reciente de esta política se
              realizó el 14 de agosto de 2024.
            </p>
            <p>
              Agradecemos que revise periódicamente esta política para estar al
              tanto de cualquier cambio que pueda haber ocurrido. Los cambios
              significativos se comunicarán a través de nuestra aplicación.
            </p>
          </div>
        </div>
        <div class="clear" />
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
export default {
  name: 'PrivacyPolicy',
  components: {
    PageHeader,
  },
};
</script>

<style lang="scss">
.main-content {
  padding-top: 20px;
  padding-bottom: 20px;
}
.fab-wrapper {
  display: none !important;
}
</style>
